import React from "react";

const ANDROID_STEPS = [
  ["Open Gwin in a supported browser", "Use Chrome, Edge or Samsung Internet directly, rather than WhatsApp or Instagram's in-app browser."],
  ["Using Chrome or Edge? You're all set! Just stay on this page and follow the steps below to install Gwin."],
  ["Open the browser menu", "Tap the three-dot menu (its location varies by browser)."],
  ["Choose Install or Add to Home screen", "Select Install app or Add to Home screen, depending on your browser."],
  ["Confirm", "Tap Install or Add when prompted."],
  ["Launch Gwin", "Open Gwin using the new icon on your Home screen."],
];

const IOS_STEPS = [
  ["Open Gwin in Safari", "On iPhone or iPad, Safari is the most reliable way to add Gwin to the Home Screen."],
  ["Open the Share menu", "Tap Share (the square with an upward arrow)."],
  ["Add to Home Screen", "Scroll through the actions and choose Add to Home Screen."],
  ["Confirm Add", "Check the app name and tap Add."],
  ["Launch Gwin", "Tap the new Gwin icon on your Home Screen."],
];

export default function InstallInstructions({ device = "android" }) {
  const ios = device === "ios";
  const steps = ios ? IOS_STEPS : ANDROID_STEPS;

  return (
    <div className="space-y-4">
      {steps.map(([title, description], index) => (
        <div key={title} className="flex items-start gap-3">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#FF914D] text-sm font-black text-white">
            {index + 1}
          </span>
          <div className="min-w-0 flex-1">
            <h3 className="text-sm font-extrabold leading-snug text-[#333333]">
              {title}
            </h3>
            <p className="mt-1 text-xs font-medium leading-relaxed text-[#757575]">
              {description}
            </p>
          </div>
        </div>
      ))}
      <p className="rounded-2xl bg-[#FFF4EC] p-3 text-xs font-semibold leading-relaxed text-[#6B5A4C]">
        If Gwin opened inside another app (for example WhatsApp or Instagram),
        copy the URL and open it in your phone's browser first.
      </p>
    </div>
  );
}
